import React from 'react';

import Image from 'next/image';

import Price from '@components/ui/price';
import DiscountLabel from '@components/ui/labels/discount/DiscountLabel';
import STATIC_ROUTES from '@data/staticRoutes.json';
import { SmallSearchViewModel } from '@api/index';
import { useAppRouter } from '@contexts/router';
import { useSearchParamsToQuery } from '@hooks/useSearchParamsToQuery';
import { optimizeImage } from '@utils/imageOptimization';

import {
  HotelImage,
  Card,
  Content,
  PriceWrapper,
  Location,
  Title,
  FromText,
  Concept,
  Button,
} from './styled';

interface HotelCardProps {
  data: SmallSearchViewModel;
}

const HotelCard: React.FC<HotelCardProps> = ({ data }) => {
  const {
    name,
    webUrl,
    mainImageUrl,
    boardType,
    address,
    price,
    discountedPrice,
    rate,
  } = data;

  const query = useSearchParamsToQuery();
  const router = useAppRouter();

  const handleClick = () => {
    if (!webUrl) return;

    const currentQuery = { ...query };

    const queryString = new URLSearchParams(
      currentQuery as Record<string, string>
    ).toString();
    router.push(`${STATIC_ROUTES.hotelPathPrefix}/${webUrl}?${queryString}`);
  };

  return (
    <Card>
      <HotelImage>
        <Image
          src={
            optimizeImage(mainImageUrl, 270, 200) ||
            '/static/images/placeholder-image.webp'
          }
          alt={name || ''}
          fill
        />
      </HotelImage>
      <Content>
        <Location>{address}</Location>
        <Concept>{boardType}</Concept>
        <Title>{name}</Title>
        <div style={{ height: 52 }}>
          {rate ? (
            <DiscountLabel discount={String(rate)} type='percent' />
          ) : null}
        </div>

        <div style={{ height: 100 }}>
          {price ? (
            <>
              <Price
                Wrapper={PriceWrapper}
                price={discountedPrice}
                originalPrice={price}
              />

              <FromText>'den itibaren</FromText>
            </>
          ) : null}
        </div>
        {webUrl && (
          <Button as='button' onClick={handleClick}>
            Oteli Gör
          </Button>
        )}
      </Content>
    </Card>
  );
};

export default HotelCard;
